import { ActivePipe } from './active.pipe';
import { BioexamsStatusPipe } from './bioexams-status.pipe';
import { CnpjPipe } from './cnpj.pipe';
import { CpfPipe } from './cpf.pipe';
import { DatabaseOptionsPipe } from './database-options.pipe';
import { DateAndTimePipe } from './date-and-time.pipe';
import { DateToFront } from './date-to-front.pipe';
import { FormatName } from './format-name.pipe';
import { PhonePipe } from './phone.pipe';
import { PrettyPrintPipe } from './pretty-print.pipe';
import { RemoveUnderscorePipe } from './remove-underscore.pipe';
import { SituationPipe } from './situation.pipe';
import { SituationRegistrationPipe } from './situation-registration.pipe';
import { TimeToFrontPipe } from './time-to-front.pipe';
import { TrueFalsePipe } from './truefalse.pipe';
import { TurnPipe } from './turn.pipe';
import { TypeDocumentPipe } from './type-document.pipe';
import { TypeGroupPipe } from './type-group.pipe';
import { TypeOfPaymentsIconPipe } from './type-payments-icon.pipe';
import { TypeOfPracticalSchedulingPipe } from './type-of-practical-scheduling.pipe';
import { TypePeoplePipe } from './type-people.pipe';
import { TypeProductPipe } from './type-product.pipe';
import { TypeReleasePipe } from './type-release.pipe';
import { FinancialPeopleSituationPipe } from './financial-people-situation-pipe';
import { FinancialReleaseGroupTypePipe } from './financial-release-group-type.pipe';
import { FinancialOccurrenceTypePipe } from './financial-occurrence-type.pipe';
import { FinancialPeopleAddresPipe } from './financial-people-address.pipe';
import { TypeOfPaymentsPipe } from './type-payments.pipe';
import { SafeUrlPipe } from './safe-url.pipe';

export const Pipes = [
  ActivePipe,
  BioexamsStatusPipe,
  CnpjPipe,
  CpfPipe,
  DatabaseOptionsPipe,
  DateToFront,
  DateAndTimePipe,
  FormatName,
  FinancialPeopleSituationPipe,
  FinancialOccurrenceTypePipe,
  FinancialPeopleAddresPipe,
  PhonePipe,
  SituationPipe,
  SituationRegistrationPipe,
  PrettyPrintPipe,
  RemoveUnderscorePipe,
  FinancialReleaseGroupTypePipe,
  TimeToFrontPipe,
  TrueFalsePipe,
  TurnPipe,
  TypePeoplePipe,
  TypeReleasePipe,
  TypeDocumentPipe,
  TypeGroupPipe,
  TypeOfPaymentsIconPipe,
  TypeOfPaymentsPipe,
  TypeOfPracticalSchedulingPipe,
  TypeProductPipe,
  SafeUrlPipe,
];
